import { render, staticRenderFns } from "./EnterpriseWelcome.vue?vue&type=template&id=277cfd3c"
import script from "./EnterpriseWelcome.vue?vue&type=script&lang=js"
export * from "./EnterpriseWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports